import { Sparkles, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface GuestTrialBannerProps {
  onSignUp: () => void;
}

export function GuestTrialBanner({ onSignUp }: GuestTrialBannerProps) {
  return (
    <div className="bg-gradient-to-r from-primary/10 to-primary/5 border-b border-primary/20 px-4 py-2">
      <div className="flex items-center justify-between gap-3 max-w-4xl mx-auto">
        <div className="flex items-center gap-2 text-sm">
          <Sparkles className="w-4 h-4 text-primary" />
          <span className="text-muted-foreground">
            Try it free — <span className="font-medium text-foreground">sign up to save your chats</span>
          </span>
        </div>
        <Button
          size="sm"
          onClick={onSignUp}
          className="h-8 gap-1.5"
        >
          <UserPlus className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Sign up free</span>
          <span className="sm:hidden">Sign up</span>
        </Button>
      </div>
    </div>
  );
}
